import { objectTypes, toObjectTypes } from './types';
export const ASSOCIATION_OBJECT_PROPERTIES = {
  contacts: ['company', 'createdate', 'email', 'firstname', 'lastmodifieddate', 'lastname', 'phone', 'website'],
  companies: ['city', 'createdate', 'domain', 'hs_lastmodifieddate', 'industry', 'name', 'phone', 'state', 'hs_avatar_filemanager_key'],
  deals: ['amount', 'closedate', 'createdate', 'dealname', 'dealstage', 'hs_lastmodifieddate', 'hubspot_owner_id', 'pipeline', 'deal_currency_code'],
  tickets: ['createdate', 'hs_lastmodifieddate', 'hs_pipeline', 'hs_pipeline_stage', 'hs_ticket_priority', 'hubspot_owner_id', 'subject'],
  meetings: ['hs_meeting_title', 'hs_activity_type', 'hs_meeting_location', 'hs_meeting_location_type', 'hs_meeting_source', 'hubspot_owner_id', 'hs_all_assigned_business_unit_ids', 'hs_engagement_source', 'hs_meeting_external_url']
};
export const DEAL_CURRENCY_FIELD_NAME = 'deal_currency_code';
export const DEAL_AMOUNT_FIELD_NAME = 'amount';
export const MAP_DEAL_REFERENCE_TYPE_TO_TRANSACTION = {
  hs_tcv: 'TCV',
  hs_acv: 'ACV',
  hs_arr: 'ARR',
  hs_mrr: 'MRR',
  legacy: 'legacy',
  disabled: 'manual'
};
export const ASSOCIATE_TAB_ID = 'associate';
export const CREATE_TAB_ID = 'create';
export const CARDINALITY_TYPES = {
  ONE_TO_MANY: 'ONE_TO_MANY',
  ONE_TO_ONE: 'ONE_TO_ONE'
};
export const PRODUCT_REQUEST_PROPERTIES = ['createdate', 'hs_created_by_user_id', 'hs_lastmodifieddate', 'hs_object_id', 'hs_object_source', 'hs_object_source_id', 'hs_object_source_user_id', 'hs_updated_by_user_id', 'name', 'price', 'hs_sku', 'hs_avatar_filemanager_key', 'hs_createdate', 'hs_folder_id', 'hs_images', 'hs_merged_object_ids', 'hs_product_type', 'hs_read_only', 'hs_unique_creation_key', 'hs_url', 'hs_was_imported', 'hubspot_owner_assigneddate', 'hubspot_owner_id', 'hubspot_team_id', 'quantity', 'discount', 'amount', 'hs_cost_of_goods_sold', 'hs_discount_percentage', 'recurringbillingfrequency', 'tax', 'hs_recurring_billing_period', 'currency', 'hs_tax_rate'];
export const PROPERTY_REFERENCE_TYPES = {
  OWNER: 'OWNER',
  TEAM: 'TEAM',
  PIPELINE: 'PIPELINE',
  PIPELINE_STAGE: 'PIPELINE_STAGE',
  MULTI_CURRENCY_CURRENCY_CODE: 'MULTI_CURRENCY_CURRENCY_CODE',
  PERSONA: 'PERSONA',
  SEQUENCE: 'SEQUENCE',
  WORKFLOW: 'WORKFLOW',
  BUSINESS_UNIT: 'BUSINESS_UNIT',
  ORIGINAL_SOURCE_1: 'ORIGINAL_SOURCE_1',
  CAMPAIGN: 'CAMPAIGN',
  TASK_QUEUE: 'TASK_QUEUE',
  CRM_OBJECT: 'CRM_OBJECT',
  USER: 'USER',
  CHANNEL_INSTANCE: 'CHANNEL_INSTANCE',
  GENERIC_CHANNEL: 'GENERIC_CHANNEL',
  TRACKED_TERM: 'TRACKED_TERM',
  SEQUENCE_WITH_PERMISSIONS: 'SEQUENCE_WITH_PERMISSIONS',
  PIPELINE_WITH_PERMISSIONS: 'PIPELINE_WITH_PERMISSIONS',
  PIPELINE_STAGE_WITH_PERMISSIONS: 'PIPELINE_STAGE_WITH_PERMISSIONS',
  CRM_OBJECT_TAG: 'CRM_OBJECT_TAG',
  STATIC_INBOUND_DB_LIST: 'STATIC_INBOUND_DB_LIST',
  OPTIMIZATION_TYPE: 'OPTIMIZATION_TYPE',
  CALL_DISPOSITION: 'CALL_DISPOSITION'
};
export const PROPERTY_NAME_TO_REFERENCE_TYPE = {
  [toObjectTypes.contact]: {},
  [toObjectTypes.company]: {},
  [toObjectTypes.deal]: {
    pipeline: PROPERTY_REFERENCE_TYPES.PIPELINE,
    dealstage: PROPERTY_REFERENCE_TYPES.PIPELINE_STAGE,
    deal_currency_code: PROPERTY_REFERENCE_TYPES.MULTI_CURRENCY_CURRENCY_CODE
  },
  [toObjectTypes.ticket]: {
    hs_pipeline: PROPERTY_REFERENCE_TYPES.PIPELINE,
    hs_pipeline_stage: PROPERTY_REFERENCE_TYPES.PIPELINE_STAGE
  },
  [toObjectTypes.meeting]: {}
};
export const OBJECT_TYPE_TO_CARD_DEFAULT_PROPERTIES = {
  [objectTypes.contacts]: ['firstname', 'lastname'],
  [objectTypes.companies]: ['name'],
  [objectTypes.deals]: ['dealname'],
  [objectTypes.tickets]: ['subject'],
  [objectTypes.meetings]: ['hs_meeting_title']
};
export const DEAL_LINE_ITEM_DEFAULT_ID = -36;
export const LINKED_PROPERTIES_CONFIG = {
  [objectTypes.contacts]: {},
  [objectTypes.companies]: {},
  [objectTypes.deals]: {
    pipeline: {
      relatedProperty: 'dealstage',
      referenceType: PROPERTY_REFERENCE_TYPES.PIPELINE_STAGE
    },
    dealstage: {
      relatedProperty: 'pipeline',
      referenceType: PROPERTY_REFERENCE_TYPES.PIPELINE
    }
  },
  [objectTypes.tickets]: {
    hs_pipeline: {
      relatedProperty: 'hs_pipeline_stage',
      referenceType: PROPERTY_REFERENCE_TYPES.PIPELINE_STAGE
    },
    hs_pipeline_stage: {
      relatedProperty: 'hs_pipeline',
      referenceType: PROPERTY_REFERENCE_TYPES.PIPELINE
    }
  },
  [objectTypes.meetings]: {}
};
export const LOAD_MORE_OPTION_VALUE = '__LOAD_MORE_OPTION__';